// extracted by mini-css-extract-plugin
module.exports = {"pricing__item":"style-module--pricing__item--139vq","pricing__price":"style-module--pricing__price--3qxp6","pricing__prices":"style-module--pricing__prices--31ZI9"};